import React from 'react'
import {CheckCircleFilled} from "@ant-design/icons";

interface Props {}

const FeatureCard = ({title, desc}) => {

  return (
    <div className="bg-white/60 backdrop-blur-sm rounded-xl border border-gray-100 hover:shadow-md hover:bg-white/80 transition-all duration-200">
      <div className="p-5">
        <div className={"flex flex-row gap-2.5 items-start mb-2"}>
          <CheckCircleFilled className="text-emerald-500 text-base mt-0.5"/>
          <p className="text-sm font-medium text-gray-800">{title}</p>
        </div>
        <p className={"text-xs text-gray-500 leading-relaxed pl-6"}>{desc}</p>
      </div>
    </div>
  )
}

export default FeatureCard
